import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    DialogContentText,
    Switch,
    FormGroup,
    FormControlLabel,
} from "@material-ui/core";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import { getDistinctModules } from "../utils";

const formatQuery = (o) => {
    return Object.keys(o)
        .map((i) => `${encodeURIComponent(i)}=${encodeURIComponent(o[i])}`)
        .join("&");
};

const authServerUrl = "https://account.wildsky.dev";
const authModuleRegistryClientId = "44C491AFBA676D1E-qpI4ooy7RBLyasJHTGzTrzSiyc5ThP6s.module.wildsky.dev";
const authModuleRegistryClientRedirectURL = "https://module.wildsky.dev/admin";

const ModuleItem = (props) => {
    const [open, setOpen] = useState(false);

    const handleDisplay = async () => {
        await props.client.toggleModuleVisible(props.module);
        await props.getModules();
    };

    const handleDelete = async () => {
        handleClose();
        props.hasVersion
            ? await props.client.deleteModuleByVersion(props.module)
            : await props.client.deleteModule(props.module);
        await props.getModules();
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const deleteDialog = (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
        >
            <DialogTitle id='alert-dialog-title'>{"Warning"}</DialogTitle>
            <DialogContent>
                <DialogContentText id='alert-dialog-description'>
                    {props.hasVersion
                        ? `Are you sure you want to delete the module ${props.module.id} ${props.module.version}?`
                        : `Are you sure you want to delete the module ${props.module.id}?`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleDelete} autoFocus>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );

    return (
        <>
            {deleteDialog}
            <Grid container style={{ marginTop: "2px" }}>
                <Grid item xs={3}>
                    {props.module.id}
                </Grid>
                {props.hasVersion && (
                    <>
                        <Grid item xs={3}>
                            {props.module.version}
                        </Grid>
                        <Grid item xs={3}>
                            {props.module.visible === true
                                ? "Visible"
                                : "Hidden"}
                        </Grid>
                    </>
                )}
                <Grid item xs={3}>
                    {props.hasVersion && (
                        <Button
                            variant='outlined'
                            color='primary'
                            onClick={handleDisplay}
                        >
                            {props.module.visible === true ? "Hide" : "Display"}
                        </Button>
                    )}
                    <Button
                        variant='outlined'
                        color='secondary'
                        style={{ marginLeft: "4px" }}
                        onClick={handleClickOpen}
                    >
                        Delete
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};

const ModuleManager = (props) => {
    const [modules, setModules] = useState(null);
    const [filter, setFilter] = useState("");
    const [versionView, setVersionView] = useState(true);
    const history = useHistory();

    useEffect(async () => {
        await getModules();
    }, []);

    const getModules = async () => {
        const response = await props.client.searchModuleMeta();
        setModules(response.Items);
    };

    const logout = () => {
        props.client.logout();
        history.push("/");
    };

    const triggerView = () => {
        setVersionView(!versionView);
    };

    const header = (
        <Grid container style={{ marginTop: "10px" }}>
            <Grid item xs={10}>
                <div className='searchIconGroup contianer'>
                    <input
                        aria-label='Search'
                        id='searchBar'
                        role='search'
                        type='text'
                        placeholder='Search for module!'
                        onChange={(e) => setFilter(e.target.value)}
                    />
                    <FontAwesomeIcon icon={faSearch} />
                </div>
            </Grid>
            <Grid item xs={2}>
                <Button variant='contained' color='primary' onClick={logout}>
                    Log Out
                </Button>
            </Grid>
        </Grid>
    );

    const trigger = (
        <Grid container style={{ marginTop: "10px" }}>
            <Grid item xs={2}>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Switch
                                defaultChecked
                                color='primary'
                                onChange={triggerView}
                            />
                        }
                        label='Manage By Version'
                    />
                </FormGroup>
            </Grid>
        </Grid>
    );

    const manageByVersion = (
        <div>
            <Grid container style={{ marginTop: "10px" }}>
                <Grid item xs={3}>
                    <h3>Module Name</h3>
                </Grid>
                <Grid item xs={3}>
                    <h3>Module Version</h3>
                </Grid>
                <Grid item xs={3}>
                    <h3>Status</h3>
                </Grid>
                <Grid item xs={3}>
                    <h3>Operation</h3>
                </Grid>
            </Grid>
            <div>
                {modules ? (
                    modules.map((module, idx) =>
                        module.id.includes(filter) ? (
                            <ModuleItem
                                key={idx}
                                client={props.client}
                                module={module}
                                getModules={getModules}
                                hasVersion={true}
                            />
                        ) : null
                    )
                ) : (
                    <h5>Loading...</h5>
                )}
            </div>
        </div>
    );

    const manageByModule = (
        <div>
            <Grid container style={{ marginTop: "10px" }}>
                <Grid item xs={3}>
                    <h3>Module Name</h3>
                </Grid>
                <Grid item xs={3}>
                    <h3>Operation</h3>
                </Grid>
            </Grid>
            <div>
                {modules ? (
                    getDistinctModules(modules).map((module, idx) =>
                        module.id.includes(filter) ? (
                            <ModuleItem
                                key={idx}
                                client={props.client}
                                module={module}
                                getModules={getModules}
                                hasVersion={false}
                            />
                        ) : null
                    )
                ) : (
                    <h5>Loading...</h5>
                )}
            </div>
        </div>
    );

    return (
        <div
            className='gameListing mainContent'
            style={{ width: "100%", backgroundColor: "#f8f8f8" }}
        >
            {header}
            {trigger}
            {versionView ? manageByVersion : manageByModule}
        </div>
    );
};

const Authenticate = (props) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        check();
    }, []);

    const check = async () => {
        const response = await props.client.login(props.code);
        if (response.result === "OK") {
            setUser(response.user);
        }
    };

    const info = (
        <Grid
            justifyContent='center'
            alignItems='center'
            container
            style={{
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
            }}
        >
            <Grid item style={{ color: "red" }}>
                Invalid User
            </Grid>
        </Grid>
    );

    return (
        <div>
            {user ? <ModuleManager user={user} client={props.client} /> : info}
        </div>
    );
};

const AdminPage = (props) => {
    const [code, setCode] = useState(null);
    const [user, setUser] = useState(null);

    useEffect(async () => {
        if (!user) {
            const response = await props.client.checkLogin();
            if (response.user) {
                setUser(response.user);
            } else {
                const urlParams = new URLSearchParams(window.location.search);
                const authCode = urlParams.get("code");
                setCode(authCode);
            }
        }
    });

    const getAuthServerUrl = () => {
        const params = {
            response_type: "code",
            redirect_uri: authModuleRegistryClientRedirectURL,
            client_id: authModuleRegistryClientId,
            scope: "openid profile email permissions offline_access",
            prompt: "consent",
            state: Math.floor(Math.random() * (1000000 - 100000)) + 100000,
        };
        return `${authServerUrl}/auth?${formatQuery(params)}`;
    };

    const loginWithAuthServer = () => {
        window.open(getAuthServerUrl(), "_self");
    };

    const loginButton = (
        <Grid
            justifyContent='center'
            alignItems='center'
            container
            style={{
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
            }}
        >
            <Grid item>
                <Button
                    variant='contained'
                    color='primary'
                    onClick={loginWithAuthServer}
                >
                    Login
                </Button>
            </Grid>
        </Grid>
    );

    return (
        <div>
            {user ? (
                <ModuleManager user={user} client={props.client} />
            ) : code ? (
                <Authenticate code={code} client={props.client} />
            ) : (
                loginButton
            )}
        </div>
    );
};

export default AdminPage;
